<template>
  <div class="page" v-loading="listLoading">
    <!--    待发货-->
    <!--    导出   Export-->
    <!--    导入物流信息  /Delivering/importLogisticsInfo-->
    <!--    发货   /Delivering/Delivery-->
    <!--    订单详情   /Delivering/orderDetail -->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="子订单号:">
              <el-input v-model="searchData.orderNo" placeholder="子订单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品名称:">
              <el-input v-model="searchData.productSkuName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人姓名:">
              <el-input v-model="searchData.receivingName" placeholder="收货人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人电话:">
              <el-input v-model="searchData.receivingMobile" placeholder="收货人电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-form-item label="采购单号:">-->
        <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号" ></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="订单状态">-->
        <!--          <el-select @change="getStatus" v-model="value" placeholder="请选择">-->
        <!--            <el-option-->
        <!--                v-for="item in options"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-row>
          <el-col :span="6">
            <el-form-item label="外部订单号">
              <el-input v-model="searchData.OutOrderNo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商" prop="SupplierId">
              <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"
                         :remote-method="querySupplier" style="width:100%">
                <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下单时间：">
              <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
                              style="width:100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <div style="display: flex;">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
              @selection-change="selectCurrentRow" style="width: 100%" border :span-method="arraySpanMethod">
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <!--        <el-table-column prop="id" label="标记" width="100" align="center"></el-table-column>-->
      <el-table-column prop="code" label="子订单号" width="300" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.orderNo }}</div>
          <p></p>
          <!--            platformOrderType 1  京东开普勒-->
          <el-tag size="mini" v-if="scope.row.platformType === 1 && scope.row.platformOrder" type="danger">京东订单 {{
              scope.row.receivingName
            }}已下单: {{ scope.row.platformOrder }}
          </el-tag>
          <p>
            <el-tag size="mini" v-if="scope.row.isHaveAfterOrder && scope.row.outOrderNo" effect="dark" type="danger">外部订单有售后订单</el-tag>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="resellerName" label="订单来源" width="120" align="center"></el-table-column>
      <el-table-column prop="name" label="订单状态" align="center" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待采购订单</span>
          <span v-if="scope.row.status == 2">待发货订单</span>
          <span v-if="scope.row.status == 3">待收货订单</span>
          <span v-if="scope.row.status == 4">已发货订单</span>
        </template>
      </el-table-column>
      <el-table-column prop="outOrderNo" label="外部订单号" width="200" align="center"></el-table-column>
      <el-table-column label="商品信息" width="250" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].productSkuName
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品规格" align="center" width="120">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec
          }}</span>
        </template>
      </el-table-column>
      <!--        <el-table-column prop="lastModificationTime" label="优惠信息" width="200" align="center"></el-table-column>-->
      <el-table-column prop="payTotalAccount" label="实付金额" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="收货信息" width="250" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingName }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingMobile }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingProviceName }},
            {{ scope.row.receivingCityName }},{{ scope.row.receivingDistrictName }},{{
              scope.row.receivingStreetName
            }}，{{ scope.row.receivingAddress }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lastModificationTime" label="采购供应商" width="200" align="center">
        <template slot-scope="scope" class="innderTable">
          <el-table border :data="scope.row.orderPurchases" :show-header="false">
            <el-table-column label="采购供货商" prop="productSupplierName" align="center" width="200"></el-table-column>
            <el-table-column prop="orderPurchaseNo" label="采购单号" align="center" width="200">
              <!--                <template slot-scope="scopes">-->

              <!--                </template>-->
            </el-table-column>
            <el-table-column label="订单状态" align="center" width="200">
              <template slot-scope="scope">
                {{ scope.row.isShipped ? '已发货' : '未发货' }}
              </template>
            </el-table-column>
            <el-table-column label="物流信息" align="center" width="350">
              <!--                  <p> 物流公司:  {{ scope.row.orderLogistics && scope.row.orderLogistics[0] &&-->
              <!--                  scope.row.orderLogistics[0].logisticsCompanyName}} </p>-->
              <!--                  <p>公司编码  {{ scope.row.orderLogistics && scope.row.orderLogistics[0] &&-->
              <!--                  scope.row.orderLogistics[0].logisticsCompanyCode}} </p>-->
              <!--                  <p> 物流单号:  {{ scope.row.orderLogistics && scope.row.orderLogistics[0] &&-->
              <!--                scope.row.orderLogistics[0].logisticsNo}} </p>-->
              <template slot-scope="scope" v-if="scope.row.orderLogistics.length">
                <div v-for="(item, index) in scope.row.orderLogistics" :key="index">
                  <div @click="checkDeliveryDetail(item)" style="cursor:pointer">
                    <span style="display: inline-block;margin-right:10px;text-decoration:underline">物流公司:{{ item.logisticsCompanyName }}
                    </span>
                    <span style="display: inline-block;margin-right:10px;text-decoration:underline">物流单号:{{ item.logisticsNo }}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="已发货数量" prop="shipmentQuantity" align="center" width="200">
              <!--                <template slot-scope="scopes">-->

              <!--                </template>-->
            </el-table-column>
            <el-table-column label="剩余发货数量" align="center" width="200">
              <template slot-scope="scope">
                {{ scope.row.purchaseQuantity - scope.row.shipmentQuantity }}
              </template>
            </el-table-column>
            <el-table-column label="发货" align="center" width="178">
              <template slot-scope="scope">
                <el-button v-if="deliveryShow" type="primary" size="mini" @click="Delivery(scope.row)">发货
                </el-button>
                <el-button v-if="updateLogisShow" type="primary" size="mini" @click="updateLogis(scope.row)">更新物流
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="lastModificationTime" label="采购单号" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="订单状态" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="物流信息" width="350" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="已发货数量" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="剩余发货数量" width="200" align="center">
        <template slot-scope="scope">
        </template>
      </el-table-column>
      <el-table-column label="发货" width="200" align="center"></el-table-column>
      <el-table-column width="300" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <!--                        <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
          <!--                                   @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
          <!--                        </el-button>-->
          <el-button v-if="detailShow" size="mini" type="primary" @click="orderDetail(scope.row)">
            订单详情
          </el-button>
          <el-button v-if="scope.row.platformOrder === null && scope.row.platformType === 1
          && scope.row.platformCode !== null && scope.row.platformCode !== ''" size="mini" type="primary"
                     @click="kplOrder(scope.row)">
            开普勒下单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="deliveryDialog" :show-close="false" :close-on-click-modal="false" width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <!--        <el-form-item label="采购供应商">-->
        <!--          <el-input v-model="form.productSupplierName" :disabled="true"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="物流公司：">-->
        <!--          <el-autocomplete-->
        <!--              v-model="form.logisticsCompanyName"-->
        <!--              :fetch-suggestions="querySearchAsync"-->
        <!--              placeholder="请选择物流公司 可搜索"-->
        <!--              @select="handleSelect"-->
        <!--          ></el-autocomplete>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="物流单号">-->
        <!--          <el-input-->
        <!--              v-model="form.logisticsNo"-->
        <!--          >-->
        <!--          </el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="需发货数量">
          <el-input v-model="form.purchaseQuantity" placeholder="8" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="已发货数量">
          <el-input v-model="form.shipmentQuantity" placeholder="8" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="剩余发货数量">
          <el-input v-model="form.remainQuantity" placeholder="8" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="选择发货数量">
          <el-input-number v-model="form.currentShipmentQuantity" :min="1" :max="1000" label="描述文字"></el-input-number>
          <!--          <el-input-->
          <!--              v-model="form.currentShipmentQuantity"-->
          <!--              placeholder="8"-->
          <!--              :disabled="true">-->
          <!--          </el-input>-->
        </el-form-item>
        <el-form-item label="选择发货仓库">
          <el-button type="primary" size="small" @click="getWarehouseInfos">请选择仓库</el-button>
          <!--          <el-select @change="getWarehouseInfo" v-model="form.warehouseName" placeholder="仓库选择">-->
          <!--            <el-option-->
          <!--                v-for="item in wareHouseData"-->
          <!--                :key="item.warehouseId"-->
          <!--                :label="item.warehouseName"-->
          <!--                :value="item">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <el-form-item v-if="isShowChooseData" label="已选择仓库:">
          &nbsp; &nbsp; 仓库名称: {{ currentWarehouseData.warehouseName }}, &nbsp; &nbsp;
          可用库存：{{ currentWarehouseData.stock }} &nbsp; &nbsp;
          是否符合: {{ currentWarehouseData.isAccord ? '符合' : '不符合' }}
        </el-form-item>
      </el-form>
      <!--          </div>-->

      <span slot="footer" class="dialog-footer">
        <el-button @click="batchCreateCancel">取 消</el-button>
        <!--        <el-button :loading="buttonLoading" type="primary" @click="batchCreate">确 定</el-button>-->
        <el-button type="primary" @click="batchCreate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
               :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
                   :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!--    <el-dialog-->
    <!--        title="发货"-->
    <!--        :visible.sync="deliveryDialog"-->
    <!--        width="40%"-->
    <!--        :close-on-click-modal="false"-->
    <!--    >-->
    <!--      <el-form-->
    <!--          label-width="120px"-->
    <!--          style="background: none"-->
    <!--      >-->
    <!--        <el-form-item label="采购供应商">-->
    <!--          <el-input v-model="form.name"></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="物流公司">-->
    <!--          <el-select-->
    <!--              v-model="form.region"-->
    <!--              filterable-->
    <!--              placeholder="请选择物流公司"-->
    <!--          >-->
    <!--            <el-option-->
    <!--                v-for="(item, index) in logisticsList"-->
    <!--                :key="index"-->
    <!--                :label="item.ShortName"-->
    <!--                :value="item.Id"-->
    <!--            ></el-option>-->
    <!--          </el-select>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="物流单号">-->
    <!--          <el-input ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="需发货数量">-->
    <!--          <span>{{ 2 }}</span>-->
    <!--          <span style="margin-left: 30px"-->
    <!--          >已发货{{ 2 }}</span-->
    <!--          >-->
    <!--          <span style="margin-left: 30px"-->
    <!--          >未发货{{ 2 }}</span-->
    <!--          >-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="当前发货数量">-->
    <!--          <el-input-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="外部订单号">-->
    <!--          <el-input v-model=""></el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--            <el-button @click="deliveryDialog = false">取 消</el-button>-->
    <!--            <el-button type="primary" @click="deliveryDialog = false">确 定</el-button>-->
    <!--      </span>-->
    <!--    </el-dialog>-->
    <el-dialog v-if="chooseDialog" title="选择发货仓库" :visible.sync="chooseDialog" :show-close="false"
               :close-on-click-modal="false" width="60%">

      <el-table :data="logisData" border highlight-current-row @current-change="handleCurrentChange1"
                style="width: 100%">
        <el-table-column prop="warehouseId" align="center" label="id" width="80">
        </el-table-column>
        <el-table-column prop="warehouseName" align="center" label="仓库名称" width="80">
        </el-table-column>
        <el-table-column align="center" label="是否符合">
          <template slot-scope="scope">
            {{ scope.row.isAccord ? '符合' : '不符合' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="stock" label="可用库存">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose">取 消</el-button>
        <!--        <el-button :loading="buttonLoading" type="primary" @click="confirmChoose">确 定</el-button>-->
        <el-button type="primary" @click="confirmChoose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流更新" :visible.sync="updateLoggisDialog" :show-close="false" :close-on-click-modal="false"
               width="80%">
      <el-table :data="updateLogisData" border style="width: 100%">
        <!--        <el-table-column-->
        <!--            prop="warehouseName"-->
        <!--            align="center"-->
        <!--            label="id"-->
        <!--            width="80">-->
        <!--        </el-table-column>-->
        <el-table-column prop="warehouseName" align="center" label="发货仓库" width="180">
        </el-table-column>
        <el-table-column align="center" prop="shipmentQuantity" label="总发货数量">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsCompanyName"-->
        <!--            label="物流公司">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsNo"-->
        <!--            label="物流单号">-->
        <!--        </el-table-column>-->
        <el-table-column prop="shippedQuantity" align="center" label="更新物流数量">
        </el-table-column>
        <el-table-column align="center" label="物流记录">
          <template slot-scope="scope">
            {{ scope.row.logisticsStr | formatInfo }}
          </template>
        </el-table-column>
        <el-table-column width="250" prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="createLogis(scope.row)" v-if="isAddLogisShow" size="mini">新增</el-button>
            <el-button @click="deleteLogis(scope.row)" v-if="isDelLogisShow" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--      <el-form label-width="100px">-->
      <!--        <el-form-item label="物流公司：">-->
      <!--          <el-autocomplete-->
      <!--              v-model="updateLogis.logisticsCompanyName"-->
      <!--              :fetch-suggestions="querySearchAsync"-->
      <!--              placeholder="请选择物流公司 可搜索"-->
      <!--              @select="handleSelect"-->
      <!--          ></el-autocomplete>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="物流单号">-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticsNo"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->

      <!--        </el-form-item>-->
      <!--        <el-form-item label='此单发货数量'>-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticQuantity"-->
      <!--                placeholder="请输入发货数量"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateLogisCancel">取 消</el-button>
        <el-button type="primary" @click="updateLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增物流" :visible.sync="createLoggisDialog" :show-close="false" :close-on-click-modal="false"
               width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <el-form-item label="物流公司：">
          <el-autocomplete v-model="addLogis.logisticsCompanyName" :fetch-suggestions="querySearchAsync"
                           placeholder="请选择物流公司 可搜索" @select="handleSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="addLogis.logisticsNo">
          </el-input>
        </el-form-item>
        <el-form-item label='此单发货数量'>
          <el-input v-model="addLogis.currentShipmentQuantity">
          </el-input>
        </el-form-item>
      </el-form>
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="createLogisCancel">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="createLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog title="查询物流详情" :visible.sync="loggisDetailDialog" :show-close="false" :close-on-click-modal="false"
               width="40%">
      <div v-if="loggisDetailList.length">
        <div v-for="(item, i) in loggisDetailList" :key="i" style="margin-bottom:10px;padding-bottom:10px;border-bottom:1px dashed #eee">
          <p style="color:#999;font-size:12px;margin-bottom:5px;">{{item.time}}</p>
          <p style="color:#333;font-size:14px;">{{item.description}}</p> 
        </div>
      </div>
      <div v-if="loadLoggisDetailEnd&&!loggisDetailList.length" style="text-align:center;color:#999;font-size:14px;padding:30px 0;">暂无物流信息！</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loggisDetailDialog=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderLogisticGet,
  LogisticsCompanyServiceGetAll,
  SupplierGetAll,
  GetAllInventoryItems,
  OrderExport,
  OrderLogisticUpload,
  BatchCreate, //新增物流
  GetAllInventoryItemsWithOrder,
  OrderWarehouseCreate,
  OrderWarehouseGetAll, OrderAfterSaleWarehouseGetAll, OrderAfterSaleLogisticCreate,
  OrderAfterSaleLogisticDelete,  //物流更新列表
  JdCtpOrder, CreateSysReseller, UpdateSysReseller, AutoJdCtpOrder,
  GetOrderLogistics
} from "../../../api/api";
import {getButtonList} from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: {Toolbar},
  data() {
    return {
      num: 1,
      deliveryDialog: false,
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        status: 2,
        orderPurchaseNo: null,
        CreationStartTime: null,
        CreationEndTime: null,
        OutOrderNo: "",
        SupplierId: ""
      },
      options: [{
        value: '2',
        label: '待发货'
      }, {
        value: '3',
        label: '已发货'
      }],
      value: '',
      form: {
        // productSupplierName: '',
        logisticsNo: '',
        orderId: '',
        orderPurchaseId: '',
        logisticsCompanyId: '',
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        currentShipmentQuantity: null,
        // currentShipmentQuantity: null,
        // remainQuantity: null,
        // productSupplierId: null,
        purchaseQuantity: '',
        // purchaseTotal: '',
        // purchasePrice: '',
        // orderNo: '',
        warehouseId: null,
        warehouseName: '',
      },
      logisCompanyData: [],
      wareHouseData: [],
      wareHouseName: '',
      deliveryShow: false,
      detailShow: false,
      buttonLoading: false,
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      isAddLogisShow: false,
      isDelLogisShow: false,
      isKplOrder: false,
      // 展示发货的仓库信息
      currentWarehouseData: {
        warehouseName: '',
        stock: '',
        isAccord: '',
        warehouseId: null
      },
      logisData: [], // 获取的仓库信息
      chooseDialog: false, // 选择仓库弹框
      isShowChooseData: false, // 是否隐藏选择的仓库数据
      updateLoggisDialog: false,
      isUpateLogisShow: false,
      updateLogisData: [],
      // updateLogis: {
      //   logisticsCompanyId: null,
      //   logisticsCompanyName: '',
      //   logisticsNo: '',
      //   logisticQuantity: null,
      // },
      showRecordDialog: false,
      recordData: [],
      createLoggisDialog: false,
      addLogis: {
        orderId: null,
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        logisticsNo: '',
        currentShipmentQuantity: null,
        orderPurchaseId: null,
        orderWarehouseId: null,
        // orderAfterSaleWarehouseId:null,
      },
      currentId: null,
      supplier: [],

      loggisDetailDialog: false,
      loggisDetailList: [],
      loadLoggisDetailEnd: false,
      logisDetailShow: false
    };
  },
  filters: {
    formatInfo(vale) {
      console.log('====', vale)
      if (vale) {
        return vale.split(',').join('  |  ')
      }
    }
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableData();
    this.getAllCompany();
    this.querySupplier()
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      })

      this.buttonList_toolBar = toolBarButtonList;
      console.log('this.buttonList_toolBa', this.buttonList_toolBar)
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });

      buttonList.forEach((item) => {
        if (item.buttonFunc === "logisDetail") {
          this.logisDetailShow = true;
        }
      })
      console.log(this.logisDetailShow)
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "Delivery") {
          this.deliveryShow = true;
        }
      })
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "orderDetail") {
          this.detailShow = true;
        }
      })
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "updateLogis") {
          this.updateLogisShow = true;
        }
      })

      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "addLogis") {
          this.isAddLogisShow = true;
        }
      })
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "delLogis") {
          this.isDelLogisShow = true;
        }
      })

      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "kplOrder") {
          this.isKplOrder = true;
        }
      })

      this.buttonList_table = tableButtonList;
      console.log(' this.buttonList_table', this.buttonList_table)
    }
  },
  methods: {
    checkDeliveryDetail(data) {
      if (!this.logisDetailShow) return 
      this.loggisDetailList = []
      this.loadLoggisDetailEnd = false
      this.loggisDetailDialog = true
      GetOrderLogistics({
        LogisticsCompanyCode: data.logisticsCompanyCode,
        LogisticsCode: data.logisticsNo
      }).then(res => {
        if (res.data.success) {
          this.loggisDetailList = res.data.result.data
        }
        this.loadLoggisDetailEnd = true
      })
    },
    AutoJdCtpOrder() {
      this.$confirm("是否一键下单", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        // this.listLoading = true;
        let res = await AutoJdCtpOrder({isSkipCostPirce:6});
        console.log('一键', res);
        if (res.data.success){
          // this.listLoading = false
          this.$message.success(res.data.result)
        }else{
          this.$message.error(res.data.error.message)
        }
      }).catch((err) => {
        // this.listLoading = false
        console.log(err)
      });

    },
    async kplOrder(row) {
      this.$confirm("是否确认下单", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        console.log('开普勒下单', row)
        /*
        * platformOrder 订单号
        * platformType  京东开普勒  1
        * 已下单
        * */
        console.log('row.platformOrder', row.platformOrder)
        console.log('row.platformType', row.platformType)
        // return
        if (row.platformOrder && row.platformType === 1) {
          return this.$message.error('此商品已经下单,无需重复下单')
        }

        /*
        * id 订单id
        * 未下单
        * */

        if (!row.platformOrder && row.platformType === 1 && row.id) {
          // console.log('-----');return;
          let res = await JdCtpOrder({id: row.id});
          // console.log('开普勒下单', res);

          // 下单成功
          if (res.data.result.success && res.data.result.code !== -1) {
            this.$message.success('下单成功');
            await this.getTableData();
            // } else if (!res.data.success && res.data.code === -1) {
          } else if (!res.data.result.success && res.data.result.code === -1) {
            this.$confirm("下单失败：商品成本价与京东价格不一致,是否更新成本价格并重新下单?", "提示", {
              closeOnClickModal: false,
            }).then(async () => {
              let res = await JdCtpOrder({id: row.id, isSkipCostPirce: true});
              if (res.data.result.success) {
                this.$message.success(res.data.result.message || '下单成功');
                await this.getTableData();
              } else {
                this.$message.error(res.data.result.message || '下单失败, 请重试');
              }
            }).catch(() => {
            });
          } else {
            this.$message.error(res.data.result.message || '下单失败, 请重试')
          }
          /*
          * -1 价格低于京东价格 需要重新下单
          * isSkipCostPirce true
          * */
          // if () {
          //
          // }
        }
      }).catch(() => {
      });

    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=UTF-8'})
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
          "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableData();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    getStatus(val) {
      console.log('=====', val);
      this.searchData.status = val;
    },
    deleteLogis(row) {
      console.log('物流删除 row', row);
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let res = await OrderAfterSaleLogisticDelete({id: row.id});
        if (res.data.success) {
          console.log('del success')
          this.$message.success(res.data.msg || '删除成功');
          await this.freshAdd();
        } else {
          this.$message.error(res.data.error.message || '删除失败, 请重试')
        }
      }).catch(() => {
      });
    },
    querySupplier(value) {
      SupplierGetAll({
        SkipCount: 0,
        MaxResultCount: 100,
        supplierName: value
      }).then(res => {
        if (res.data.success) {
          this.supplier = res.data.result.items
        }
      })
    },
    // 新增物流
    async createLogisConfirm() {
      console.log('新增物流 this.addLogis', this.addLogis);
      // return;
      this.buttonLoading = true;
      let res = await BatchCreate(this.addLogis);
      if (res.data.success) {
        this.createLoggisDialog = false;
        this.addLogis = {
          orderId: null,
          logisticsCompanyId: null,
          logisticsCompanyName: '',
          logisticsCompanyCode: '',
          logisticsNo: '',
          currentShipmentQuantity: null,
          orderPurchaseId: null,
          orderWarehouseId: null,
        };

        this.$message.success('新增成功')
        this.buttonLoading = false;
        await this.freshAdd();
      } else {
        this.$message.error(res.data.error.message || '新增失败, 请重试')
      }
    },
    async freshAdd() {
      let res = await OrderWarehouseGetAll({orderId: this.currentId});
      console.log(' ', res);
      if (res.data.success) {
        this.updateLogisData = res.data.result.items || [];
        console.log('updateLogisData', this.updateLogisData);
        // this.addLogis.orderId = row.orderId; // 新增物流用
        // this.updateLoggisDialog = true;
        this.$message.success('刷新物流信息成功')
      } else {
        return this.$message.error(res.data.error.message || '货物物流信息失败, 请重试')
      }
    },
    createLogisCancel() {
      this.createLoggisDialog = false;
      this.buttonLoading = false;
      this.addLogis = {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        logisticsNo: '',
        currentShipmentQuantity: null,
        orderAfterSaleWarehouseId: null,
      }
    },
    createLogis(row) {
      console.log('新增物流 row', row);
      // this.addLogis.orderAfterSaleWarehouseId = row.id;
      this.addLogis.orderWarehouseId = row.id;
      this.addLogis.orderPurchaseId = row.orderPurchaseId;
      this.createLoggisDialog = true;

    },

    updateLogisCancel() {
      this.updateLoggisDialog = false;
      this.getTableData();
    },
    updateLogisConfirm() {
      this.updateLoggisDialog = false;
      this.getTableData();
    },
    // 选择发货仓库
    async getWarehouseInfos(val) {
      this.chooseDialog = true;
      // console.log('发货仓库', val);
      // this.form.warehouseName = val.warehouseName;
      // this.form.warehouseId = val.warehouseId;
      // console.log('this.form', this.form);
      // let params = {};
      // params.orderId = this.detailData.orderId;
      // params.quantity = this.detailData.afterSaleQuantity;
      // console.log('发货仓库params', params);
      // let res = await GetAllInventoryItemsWithOrder(params);
      // if (res.data.success) {
      //   this.currentWarehouseData = {
      //     warehouseName: '',
      //     stock: '',
      //     isAccord: '',
      //   };
      //   this.chooseDialog = true;
      //
      //   this.logisData = res.data.result;
      // } else {
      //   this.$message.error(res.data.error.message || '获取仓库信息失败, 请重试')
      // }
      // console.log('cangku', res);
    },
    handleCurrentChange1(val) {
      console.log('当前选择仓库', val);
      this.currentWarehouseData = {
        warehouseName: '',
        stock: '',
        isAccord: '',
        warehouseId: null,
      };
      // if (!val.isAccord) {
      //   return this.$message.error('当前仓库不可用')
      // }
      this.currentWarehouseData = val;
      this.form.warehouseId = val.warehouseId;
      this.form.warehouseName = val.warehouseName;
      this.form.logisticsCompanyCode = val.logisticsCompanyCode;
      this.isShowChooseData = true;
    },
    confirmChoose() {
      // this.currentWarehouseData = {
      //   warehouseName:'',
      //   stock:'',
      //   isAccord:'',
      // };
      this.chooseDialog = false;
    },
    cancelChoose() {
      // this.currentWarehouseData = {
      //   warehouseName: '',
      //   stock: '',
      //   isAccord: '',
      // };
      this.chooseDialog = false;

      // this.isShowChooseData = false;

      this.currentWarehouseData = {
        warehouseName: '',
        stock: '',
        isAccord: '',
      }; //清空已选择仓库数据
      this.isShowChooseData = false; // 隐藏已选的仓库
    },
    async Delivery(row) {
      console.log('发货row', row);
      let obj = {
        ProductSkuId: row.skuId,
        SkipCount: 0,
        MaxResultCount: 100,
      };
      // let res = await GetAllInventoryItems(obj);
      // console.log('仓库', res);
      // if (res.data.success) {
      //   this.wareHouseData = res.data.result.items
      //   // this.wareHouseData = res.data.result.items.map((item) => {
      //   //   return {
      //   //     value: item.warehouseName,
      //   //     id: item.warehouseId,
      //   //   };
      //   // });
      // } else {
      //   return this.$message.error(res.data.msg || '获取失败, 请重试')
      // }
      let params = {};
      params.orderId = row.orderId;
      params.quantity = this.purchaseQuantity;
      console.log('发货仓库params', params);
      // let ress = await GetAllInventoryItemsWithOrder(params);
      // if (ress.data.success) {
      //   this.currentWarehouseData = {
      //     warehouseName: '',
      //     stock: '',
      //     isAccord: '',
      //   };
      //   // this.chooseDialog = true;
      //   this.logisData = ress.data.result;
      // } else {
      //   return this.$message.error(ress.data.error.message || '获取仓库信息失败, 请重试')
      // }
      // console.log('cangku', ress);
      this.deliveryDialog = true;
      this.form.orderId = row.orderId;
      this.form.productSupplierName = row.productSupplierName;
      this.form.purchaseQuantity = row.purchaseQuantity;
      this.form.shipmentQuantity = row.shipmentQuantity;  // shiment 0
      // this.form.currentShipmentQuantity = row.purchaseQuantity;
      this.form.remainQuantity = row.purchaseQuantity - row.shipmentQuantity;
      this.form.productSupplierName = row.productSupplierName;
      this.form.productSupplierId = row.productSupplierId;
      this.form.purchaseTotal = row.purchaseTotal;
      this.form.purchasePrice = row.purchasePrice;
      this.form.orderNo = row.orderNo;
      this.form.orderPurchaseId = row.id;

      // let res = await OrderLogisticGet({id: row.id});
      // console.log('发货', res);
      // if (res.data.success) {
      //
      // } else {
      //   this.$error.message(res.data.mag || '发货失败,请重试')
      // }
      console.log('this.form', this.form)
    },
    // 更新物流
    async updateLogis(row) {
      console.log('更新物流row', row)
      this.currentId = row.orderId; //新增 删除  刷新列表用
      // this.updateLoggisDialog = true;
      let res = await OrderWarehouseGetAll({orderId: row.orderId});
      console.log('物流更新', res);
      if (res.data.success) {
        this.updateLogisData = res.data.result.items || [];
        console.log('updateLogisData', this.updateLogisData);
        this.addLogis.orderId = row.orderId; // 新增物流用
        this.updateLoggisDialog = true;
      } else {
        return this.$message.error(res.data.error.message || '货物物流信息失败, 请重试')
      }
    },
    getStatus(val) {
      console.log('=====', val);
      this.searchData.status = val;
    },
    getWarehouseInfo(val) {
      console.log('发货仓库', val);
      this.form.warehouseName = val.warehouseName;
      this.form.warehouseId = val.warehouseId;
      console.log('this.form', this.form);
    },
    handleSelect(item) {
      console.log('物流公司', item);
      // this.form.logisticsCompanyId = item.id;
      // this.form.logisticsCompanyName = item.logisticsCompanyName;
      // this.form.logisticsCompanyCode = item.code;
      this.addLogis.logisticsCompanyId = item.id;
      this.addLogis.logisticsCompanyName = item.value;
      this.addLogis.logisticsCompanyCode = item.code;
    },
    batchCreateCancel() {
      this.deliveryDialog = false;
      this.buttonLoading = false;
      this.form = {
        // productSupplierName: '',
        logisticsNo: '',
        orderId: '',
        orderPurchaseId: '',
        logisticsCompanyId: '',
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        currentShipmentQuantity: null,
        // currentShipmentQuantity: null,
        // remainQuantity: null,
        // productSupplierId: null,
        // purchaseQuantity: '',
        // purchaseTotal: '',
        // purchasePrice: '',
        // orderNo: '',
        warehouseId: null,
        // warehouseName: '',
      }
      this.isShowChooseData = false;
      this.currentWarehouseData = {
        warehouseName: '',
        stock: '',
        isAccord: '',
      }; //清空已选择仓库数据
      this.isShowChooseData = false; // 隐藏已选的仓库
    },
    async batchCreate() {
      let params = {};
      // if (!this.form.logisticsCompanyId){
      //   return this.$message.error('物流公司不能为空')
      // }
      //
      // if (!this.form.logisticsNo){
      //   return this.$message.error('物流单号不能为空')
      // }
      //
      // if (!this.form.CurrentShipmentQuantity){
      //   return this.$message.error('发货数量不能为空')
      // }
      //
      // if (!this.form.warehouseName){
      //   return this.$message.error('发货仓库不能为空')
      // }
      //
      // if(this.form.CurrentShipmentQuantity > this.form.remainQuantity){
      //   return this.$message.error('发货数量不能大于剩余发货数量')
      // }

      params.orderId = this.form.orderId;
      params.orderPurchaseId = this.form.orderPurchaseId;
      // params.productSupplierId = this.form.productSupplierId;
      // params.purchaseQuantity = this.form.purchaseQuantity;
      // params.shipmentQuantity = this.form.purchaseQuantity;
      params.shipmentQuantity = this.form.currentShipmentQuantity;
      // params.purchaseTotal = this.form.purchaseTotal;
      // params.purchasePrice = this.form.purchasePrice;
      // params.orderNo = this.form.orderNo;
      params.productSupplierName = this.form.productSupplierName;
      params.warehouseName = this.form.warehouseName;
      params.warehouseId = this.form.warehouseId;
      // params.logisticsCompanyId = this.form.logisticsCompanyId;
      // params.logisticsNo = this.form.logisticsNo;
      // params.logisticsCompanyName = this.form.logisticsCompanyName;
      // params.logisticsCompanyCode = this.form.logisticsCompanyCode;
      // params.currentShipmentQuantity = this.form.currentShipmentQuantity;
      // params.currentShipmentQuantity = this.form.purchaseQuantity; // 暂时锁定 不能分批发货
      // console.log('提交采购参数', params);return;
      this.buttonLoading = true;
      let res = await OrderWarehouseCreate(params);
      if (res.data.success) {
        this.$message.success(res.data.msg || '发货成功');
        this.form = {
          // productSupplierName: '',
          logisticsNo: '',
          orderId: '',
          orderPurchaseId: '',
          logisticsCompanyId: '',
          logisticsCompanyName: '',
          logisticsCompanyCode: '',
          currentShipmentQuantity: null,
          // currentShipmentQuantity: null,
          // remainQuantity: null,
          // productSupplierId: null,
          // purchaseQuantity: '',
          // purchaseTotal: '',
          // purchasePrice: '',
          // orderNo: '',
          warehouseId: null,
          // warehouseName: '',
        };
        this.currentWarehouseData = {
          warehouseName: '',
          stock: '',
          isAccord: '',
        }; //清空已选择仓库数据
        this.isShowChooseData = false; // 隐藏已选的仓库
        this.deliveryDialog = false;
        this.buttonLoading = false;
        await this.getTableData();
      } else {
        this.$message.error(res.data.error.message || '发货失败, 请重试')
      }
      console.log('发货', res);
    },
    getAllCompany(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.LogisticsCompanyName = key;
      }
      return new Promise((resolve, reject) => {
        LogisticsCompanyServiceGetAll(obj).then((res) => {
          console.log('物流公司list', res);
          if (res.data.success) {
            this.logisCompanyData = res.data.result.items
                .map((item) => {
                  return {
                    value: item.fullName,
                    id: item.id,
                    code: item.expressHundredCode
                  };
                });
            resolve(this.logisCompanyData);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
      console.log('this.logisCompanyData', this.logisCompanyData);
    },
    orderDetail(row) {
      // this.$router.push(
      //     `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`)
    },
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 9) {
        return [1, 7];
      } else if (columnIndex === 9) {
        return [0, 0];
      } else if (columnIndex === 10) {
        return [0, 0];
      } else if (columnIndex === 11) {
        return [0, 0];
      } else if (columnIndex === 12) {
        return [0, 0];
      } else if (columnIndex === 13) {
        return [0, 0];
      } else if (columnIndex === 14) {
        return [0, 0];
      } else if (columnIndex === 15) {
        return [0, 0];
      }
    },
    onSubmit() {
      console.log('submit!');
    },

    async getTableData() {
      this.listLoading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await OrderPurchaseGetAll(this.searchData);
      console.log('待发货订单', res);
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.msg)
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 500)
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ids: list}).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ids: list}).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getAllCompany(queryString);
        cb(res);
      } else {
        let res = await this.getAllCompany();
        cb(res);
      }
    },

    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({parentId: 0}).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.PageIndex = 1;
      this.getTableData();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.CreationStartTime = null;
        this.searchData.CreationEndTime = null;
      } else {
        this.searchData.CreationStartTime = e[0];
        this.searchData.CreationEndTime = e[1];
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        status: 2,
        orderPurchaseNo: null,
        CreationStartTime: null,
        CreationEndTime: null,
        OutOrderNo: "",
        SupplierId: ""
      };
      this.valueTime = [];
      this.getTableData();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableData();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableData();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      // this.listLoading = false;
      // GetProductList(para).then((res) => {
      //   if (res.data.success) {
      //     if (res.data.result.items) {
      //       res.data.result.items.forEach(item => {
      //         item.IsSort = false
      //       })
      //     }
      //     this.total = res.data.result.totalCount;
      //     let list = res.data.result.items || [];
      //     list.forEach((item) => {
      //       item.popoverVisible = false;
      //     });
      //     this.tableList = list;
      //     this.listLoading = false;
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // });
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table_1_column_9 .cell {
  padding: 0 !important;
}
</style>
